import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useHistory } from 'react-router-dom';
import './AppHeader.css';
import Image from "../images/favicon.png";
const AppHeader = () => {
  const { user, logout } = useAuth();
  const history = useHistory();

  const handleLogout = () => {
    logout();
    history.push('/login');
  };
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <img src={Image} alt="TickleRight" className="header-logo" />
          <h1>TR Form</h1>
        </div>
        
        <div className="header-right">
          <span className="user-welcome">Welcome, {user?.name || user?.phone}</span>
          <button onClick={handleLogout} className="logout-button">
            Sign Out
          </button>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;